import ApplicationController from './application_controller';

import { sanitizeFilename, passCsrfToken, fogUrl } from '../util/helpers';
import axios from 'axios';

export default class extends ApplicationController {
  static targets = ['inputFile', 'browseFile', 'attachmentData', 'url', 'text'];

  connect() {
    passCsrfToken(document, axios);
    this.path = document.querySelector('body').dataset.attachmentsUploadPath;
  }

  browseFile() {
    if (!this.hasInputFileTarget) return;
    this.inputFileTarget.value = null;
    this.inputFileTarget.click();
  }

  changeFile(e) {
    e.preventDefault();
    const file = e.target.files[0];

    if (!file) return;

    this._upload(file);
  }

  // PRIVATE

  _upload(file) {

    const data = this._getFormDataStuff(file).data;
    const newFileButton = this.browseFileTarget;

    axios
      .post(this.path, data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
      })
      .then(response => {
        if (this.update) {
          newFileButton.classList.remove('hidden');
        }

        const file = response.data;

        this.attachmentDataTarget.dataset.attachmentParams = JSON.stringify({
          id: file.attachment.id,
          text: file.attachment.title,
          url: file.uploaded.id,
          external: false,
          icon: 'download',
          size: file.uploaded.metadata.size,
          target: ''
        });

        this.urlTarget.value = file.uploaded.id;
        this.textTarget.value = file.attachment.title;
      })
      .catch(error => {
        console.error(error);
      });
  }

  _getFormDataStuff(file) {
    const data = new FormData();
    const sanitizedName = sanitizeFilename(file.name);
    data.append("file", file, sanitizedName);
    return { data, sanitizedName };
  }
}
